import winterImg from "@/assets/bad-ragaz-winter.jpg";
import sommerImg from "@/assets/bad-ragaz-sommer.jpg";
import pizolImg from "@/assets/bad-ragaz-pizol.avif";
import fruehlingImg from "@/assets/bad-ragaz-fruehling.jfif";
import { useLanguage } from "@/i18n/LanguageContext";
import { useCmsContent } from "@/hooks/useCmsContent";

const BadRagazSection = () => {
  const { t } = useLanguage();
  const { get } = useCmsContent();

  const seasons = [
    { label: t.badRagazSection.winter, image: pizolImg, position: "top" as const },
    { label: t.badRagazSection.spring, image: fruehlingImg, position: "bottom" as const },
    { label: t.badRagazSection.summer, image: sommerImg, position: "top" as const },
    { label: t.badRagazSection.autumn, image: winterImg, position: "bottom" as const },
  ];

  return (
    <section className="w-full">
      <div className="bg-primary py-8 md:py-12">
        <div className="hotel-container">
          <div className="grid md:grid-cols-2 gap-6 md:gap-16">
            <div>
              <h2 className="font-display text-3xl md:text-5xl font-light text-primary-foreground mb-3 md:mb-4">
                {get("badragaz_title") || t.badRagazSection.heading}
              </h2>
              <div className="w-16 h-px bg-accent mb-6" />
              <p className="font-body text-xs text-primary-foreground/70 uppercase tracking-[0.25em] mb-4">
                {get("badragaz_subtitle") || t.badRagazSection.caption}
              </p>
              <p className="font-body text-sm md:text-base text-primary-foreground/80 uppercase tracking-wider leading-relaxed mb-6">
                {t.badRagazSection.subtitle}
              </p>
              <p className="font-body text-sm md:text-base text-primary-foreground/70 leading-relaxed">
                {t.badRagazSection.values}
              </p>
            </div>
            <div className="flex flex-col justify-between">
              <p className="font-body text-sm md:text-base text-primary-foreground/80 leading-relaxed mb-6 md:mb-12">
                {get("badragaz_description") || t.badRagazSection.description}
              </p>
              <a
                href="https://portal.gastfreund.net/esos-hotel-quelle"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-8 py-3 border border-primary-foreground/40 text-primary-foreground font-body text-xs uppercase tracking-[0.2em] font-medium hover:bg-primary-foreground/10 transition-colors rounded-sm w-fit"
              >
                {t.badRagazSection.cta}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="relative py-10 md:py-16 overflow-hidden">
        <div className="absolute left-0 right-0 top-0 h-1/2 bg-primary" />
        <div className="absolute left-0 right-0 bottom-0 h-1/2 bg-background" />

        <div className="hotel-container relative z-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 items-end">
            {seasons.map((season) => (
              <div
                key={season.label}
                className={`relative group ${season.position === "top" ? "md:mb-16" : "md:mt-16"}`}
              >
                <div className="overflow-hidden border-2 border-accent/40">
                  <div className="aspect-[3/4] overflow-hidden">
                    <img src={season.image} alt={season.label} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                </div>
                <div className="mt-[-1px] inline-block bg-background border border-border px-3 py-1.5">
                  <span className="font-body text-xs md:text-sm text-foreground uppercase tracking-[0.2em] font-semibold">{season.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BadRagazSection;
